import Home from "./Home.Container";

export default Home;